// material ui icons
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// material ui
import { IconButton, Stack, Typography } from '@mui/material';

interface CopyableIdFieldProps {
  value: string | null | undefined;
  notAvailableText?: string;
  onCopy: () => void;
}

/**
 * Renders an ID value next to a copy-to-clipboard icon button.
 * The actual copy + snackbar logic is handled by the parent via `onCopy`.
 */
const CopyableIdField = ({
  value,
  notAvailableText = 'Not Available',
  onCopy,
}: CopyableIdFieldProps) => {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {value || notAvailableText}
      </Typography>
      <IconButton
        size="small"
        onClick={onCopy}
        sx={{
          color: 'text.secondary',
          '&:hover': { color: 'primary.main' },
        }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};

export default CopyableIdField;
